import { AddRolePermissionsForm } from './AddRolePermissionsForm';
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { useAviatorPermissions } from '@Modal/hooks/aviatorRoles/useAviatorPermissions';

export const AddRolePermissionsModalDialog = () => {
  const { showAddAviatorPermissionsModal, handleCloseAddRolePermissionsForm } =
    useAviatorPermissions();

  return (
    <>
      {showAddAviatorPermissionsModal && (
        <ClosableModal
          name="AddRolePermissions"
          title="Add Permissions"
          open={showAddAviatorPermissionsModal}
          onClose={handleCloseAddRolePermissionsForm}
          sx={{ width: '592px' }}
        >
          <AddRolePermissionsForm />
        </ClosableModal>
      )}
    </>
  );
};
